import { render } from "./editArticle.vue?vue&type=template&id=64e40793"
import script from "./editArticle.vue?vue&type=script&lang=js"
export * from "./editArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__